import { render, staticRenderFns } from "./AddEyesWanted.vue?vue&type=template&id=83a85be8&scoped=true&"
import script from "./AddEyesWanted.vue?vue&type=script&lang=js&"
export * from "./AddEyesWanted.vue?vue&type=script&lang=js&"
import style0 from "./AddEyesWanted.vue?vue&type=style&index=0&id=83a85be8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a85be8",
  null
  
)

export default component.exports